import { render, staticRenderFns } from "./CalendarSelect.vue?vue&type=template&id=c96852a8&"
import script from "./CalendarSelect.vue?vue&type=script&lang=js&"
export * from "./CalendarSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports